/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { Feedback } from "./Feedback";

/**
 * Request schema for the PUT /chat/event/{event_id} endpoint.
 *
 * Carries the partial updates the client may apply to an event.
 */
export interface UpdateEventRequest {
  feedback?: Feedback | null;
  comment?: string | null;
  mark_final?: boolean | null;
}
